import { ChartSettingsT } from 'business/definitions';
import { isEqual } from 'lodash';
import { useBackendSyncedContext } from 'routes/Explore/components/Contexts/BackendSyncedContext/BackendSyncedContext';
import { useSettingsDispatchContext } from 'routes/Explore/components/Contexts/SettingsContext/SettingsContext';
import { getSettingsDict } from '../helpers/helpers';

/**
 * When the chart conception is initialized, we don't want to set the backend
 * synced to false, because it's not a user change. We force this new settings
 * to get rid of the magic frontend step by step.
 * @param prevSettings - The previous chart settings
 * @param newSettings - The new chart settings
 */
const isChartConceptionInitialization = (
    prevSettings: ChartSettingsT,
    newSettings: ChartSettingsT,
) =>
    prevSettings.chartConception === undefined &&
    Boolean(newSettings.chartConception);

export const useUpdateSettings = (prevSettings: ChartSettingsT) => {
    const { setIsBackendSynced } = useBackendSyncedContext();
    const { applyChartSettings } = useSettingsDispatchContext();
    return (newSettings: ChartSettingsT) => {
        const settings = getSettingsDict({
            ...prevSettings,
            ...newSettings,
        });

        if (
            !isChartConceptionInitialization(prevSettings, newSettings) &&
            !isEqual(prevSettings, newSettings)
        ) {
            setIsBackendSynced(false);
        }
        applyChartSettings(settings);
    };
};
